import * as calistaConstant from 'src/constants/CalistaConstant'

import { Box, Paper } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { components, useServices } from 'cng-web-lib'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import CalistaUiComponentTranslationText from 'src/views/common/CalistaUiComponentTranslationText'
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import CngBackdrop from '../../../vesselschedule/searchschedule/cngcomponent/CngBackDrop'
import ConfirmDialog from 'src/components/dialog/ConfirmDialog'
import FreightBookingApiUrls from 'src/apiUrls/FreightBookingApiUrls'
import FreightBookingTranslationText from '../../shared/FreightBookingTranslationText'
import NewBookingStepperComponent from '../../components/NewBookingStepperComponent'
import ReviewBookingButtonComponent from './ReviewBookingButtonComponent'
import SubmittedBookingButtonComponent from '../../components/SubmittedBookingButtonComponent'
import ViewBookingTypeComponent from '../../components/ViewBookingTypeComponent'
import ViewCargoComponent from '../../components/ViewCargoComponent'
import ViewContainerComponent from '../../components/ViewContainerComponent'
import ViewScheduleComponent from '../../components/ViewScheduleComponent'
import ViewShipmentComponent from '../../components/ViewShipmentComponent'
import makeValidationSchema from 'src/views/freightbooking/shared/MakeValidationSchema'
import moment from 'moment'
import Utils from '../../shared/Utils'
import ViewDgCargoComponent from '../../components/ViewDgCargoComponent'
import ViewContactComponent from '../../components/ViewContactComponent'
import ViewPaymentComponent from '../../components/ViewPaymentComponent'
import ViewDocumentComponent from '../../components/ViewDocumentComponent'
import CommonUtils from 'src/views/common/utils/Utils'
import QuickScroll from 'src/components/iconbutton/QuickScroll'
const DEFAULT_INITIAL_VALUES = Object.freeze({
    bookingId: '',
    setFreightBookingId: '',
    bookingStatus: '',
    ...ViewBookingTypeComponent.initialValues,
    ...ViewScheduleComponent.initialValues,
})

const FORMIK_PROPS = {
    initialValues: { ...DEFAULT_INITIAL_VALUES },
    makeValidationSchema: makeValidationSchema
}

const {
    table: { useDefaultNotification },
    CngGridItem
} = components

function FormFields({ disabled, showNotification, shouldHideMap }) {

    const translatedTextsObject = FreightBookingTranslationText()
    const uiTranslatedTextsObject = CalistaUiComponentTranslationText()
    // const calistaConstant = CalistaConstant()
    //get data from useHistory

    const { createRecord } = useServices()
    const history = useHistory()
    const location = useLocation();
    const data = location.state
    const containers = location.state.bookingContainers;
    const cargo = location.state.bookingCargoes;
    const dgCargo = location.state.bookingDGCargoes || []
    const documents = getDocumentList()
    const [loading, setLoading] = useState(false)
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [bookingStep, setBookingStep] = useState(1)
    const bookingId = useRef()
    const freightBookingId = useRef()
    const [bookingStatus, setBookingStatus] = useState()
    const [isSubmitted, setIsSubmitted] = useState(false)

    function getDocumentList() {

        if (data.bookingStatus == calistaConstant.BOOKING_STATUS_PENDING_APPROVAL) {
            //step 3 , booking document only
            return location.state.bookingDocuments == null ? [] : location.state.bookingDocuments
        } else {
            //step 2 , combine document and pending document list
            let pendingList = location.state.pendingBookingDocuments == null ?
                [] :
                processPendingDocList(location.state.pendingBookingDocuments)
            return location.state.bookingDocuments == null ? (pendingList) : location.state.bookingDocuments.concat(pendingList)
        }


    }


    function processPendingDocList(pendingDocList) {
        console.log('testdoc, pendingDocList start', pendingDocList)
        pendingDocList.forEach((doc) => {
            doc.docType = doc.fields[0].value
            doc.description = doc.fields[1].value
        })

        console.log('testdoc, pendingDocList end', pendingDocList)
        return pendingDocList
    }

    const {
        success: showSuccessNotification,
        error: showErrorNotification
    } = useDefaultNotification(showNotification)

    const onEdit = () => {
        // alert('edit' + JSON.stringify(data))
        history.push({
            pathname: '/cal-freightbooking/create-new-booking',
            state: { booking: data }
        })
    }

    const onSaveDraft = () => {
        setLoading(true)
        console.log('saveDraft')

        if (data.pendingBookingDocuments && !Utils.isEmpty(data.pendingBookingDocuments)) {
            uploadDocumentAndSubmitBooking(false)
        } else {
            saveDraft(data)
        }


    }


    function saveDraft(newBookingData) {
        function onSuccess(response) {
            console.log('connection-request onSuccess', response)
            if (response.errorMessages != null) {
                showErrorNotification(response.errorMessages)
            } else {
                showSuccessNotification(`${translatedTextsObject.saveDraftSuccess} ${response.freightBookingId}`)
                newBookingData.bookingId = response.bookingId
                newBookingData.freightBookingId = response.freightBookingId
                navigateMyBooking()
            }
            setLoading(false)
        }

        function onError(error) {
            console.log('connection-request error', error.message)
            setLoading(false)
            showErrorNotification(CommonUtils.getErrorMessage(error))
        }

        createRecord.execute(
            FreightBookingApiUrls.SAVE_DRAFT,
            newBookingData,
            onSuccess,
            onError
        )

    }

    function onSubmitBooking() {
        setLoading(true)
        console.log('submit booking')


        if (data.pendingBookingDocuments && !Utils.isEmpty(data.pendingBookingDocuments)) {
            uploadDocumentAndSubmitBooking(true)
        } else {
            submitBooking(data)
        }
    }

    function uploadDocumentAndSubmitBooking(isSubmitBooking) {

        setLoading(true)
        var formData = new FormData();
        console.log(data.pendingBookingDocuments)

        data.pendingBookingDocuments.map((file, i) => {
            var fileBlob = file.file
            console.log(fileBlob)
            formData.append("fileContents", fileBlob); // name of the file upload box 

        })

        function onSuccess(response) {
            console.log('connection-request onSuccess', response)
            // setLoading(false)
            if (response.errorMessages != null) {

                showErrorNotification(response.errorMessages)

            } else {
                //showSuccessNotification(`${translatedTextsObject.saveDraftSuccess} ${response.freightBookingId}`)
                console.log(response)
                let bookingDocs = data.bookingDocuments || [] //to store the final booking documents
                if (response && response.length > 0) {
                    response.map((file, i) => {
                        let bookingDoc = {
                            docType: data.pendingBookingDocuments[i].fields[0].value,
                            filename: file.fileName,
                            description: data.pendingBookingDocuments[i].fields[1].value,
                            docId: file.id,
                            filesize: file.fileSize
                        }

                        bookingDocs.push(bookingDoc)
                    })
                }

                data.bookingDocuments = bookingDocs

                console.log(data)
                if (isSubmitBooking) {
                    submitBooking(data)
                } else {
                    saveDraft(data)
                }
            }
        }

        function onError(error) {
            console.log('connection-request error', error.message)
            setLoading(false)
            showErrorNotification(CommonUtils.getErrorMessage(error))
        }

        createRecord.execute(
            FreightBookingApiUrls.DOCUMENT_UPLOAD,
            formData,
            onSuccess,
            onError
        )
    }

    function submitBooking(newBookingData) {
        console.log("submitBooking")
        console.log(newBookingData)
        function onSuccess(response) {
            console.log('connection-request onSuccess', response)
            if (response.errorMessages != null) {
                showErrorNotification(response.errorMessages)
            } else {
                showSuccessNotification(`${translatedTextsObject.submitSuccess} ${response.freightBookingId}`)
                newBookingData.bookingId = response.bookingId
                newBookingData.freightBookingId = response.freightBookingId
                newBookingData.bookingStatus = response.bookingStatus
            }
            setLoading(false)

            history.push({
                pathname: '/cal-freightbooking/create-new-booking/submitted',
                state: newBookingData
            })
        }

        function onError(error) {
            console.log('connection-request error', error.message)
            setLoading(false)
            showErrorNotification(CommonUtils.getErrorMessage(error))
        }

        createRecord.execute(
            FreightBookingApiUrls.SUBMIT_BOOKING,
            newBookingData,
            onSuccess,
            onError
        )
    }

    const onDiscard = () => {
        setConfirmDialogOpen(true)
    }

    const navigateMyBooking = () => {
        history.push({
            pathname: '/cal-freightbooking/my-booking'
        })
    }


    useEffect(() => {
        console.log('populate review representativeName ' + data.representativeName)
        setBookingStatus(data.bookingStatus)

        if (data.bookingStatus != 'undefined') {
            if (data.bookingStatus == calistaConstant.BOOKING_STATUS_PENDING_APPROVAL) {
                setIsSubmitted(true)
                setBookingStep(2)
            }
        }
    }, [])

    return (
        <Box id="top-level-box">
            <CngGridItem xs={12} sm={9} shouldHide={loading ? false : true}>
                <CngBackdrop loading={loading} />
            </CngGridItem>
            <Paper>
                <Box alignItems='center' pr={15} pl={15}>
                    <NewBookingStepperComponent activeStep={bookingStep} />
                </Box>

                {/* {JSON.stringify(location.state)} */}

                <Box p={5} borderTop={1} borderBottom={1} className="border-light-blue" >
                    <Box fontWeight={600} fontSize="h3.fontSize" >
                        <Box display={isSubmitted ? 'none' : ''}>
                            {translatedTextsObject.reviewBooking}
                        </Box>
                        <Box display={isSubmitted ? '' : 'none'}>
                            <Box display="flex" flexDirection="row">
                                {translatedTextsObject.bookingSubmitted}
                                <Box pl={1.5}>
                                    <CheckCircleOutlineOutlinedIcon className='light-green' />
                                </Box>

                            </Box>
                            <Box className='info-label' pt={2} mb={-2}>
                                {translatedTextsObject.bookingSubmittedOn}
                                {moment().format(' MMMM Do yyyy')}
                            </Box>
                        </Box>
                    </Box>
                    <Box pt={5}>
                        <CngGridItem xs={4} sm={4}>
                            <ViewBookingTypeComponent.FormBody bookingTypeData={data} />
                        </CngGridItem>
                    </Box>
                    <Box pt={5}>
                        <ViewScheduleComponent.FormBody scheduleData={data} showDetails />
                    </Box>
                    <Box pt={5}>
                        <ViewShipmentComponent.FormBody shipmentData={data} showDetails />
                    </Box>
                    <Box pt={5}>
                        <ViewContainerComponent.FormBody containers={containers} showDetails />
                    </Box>

                    {data.hazardous ?
                        (<Box pt={5}> <ViewDgCargoComponent.FormBody cargo={dgCargo} showDetails />  </Box>)
                        :
                        (<Box pt={5}> <ViewCargoComponent.FormBody cargo={cargo} showDetails />   </Box>)
                    }


                    {documents.length > 0 && (
                        <Box pt={5}>
                            <ViewDocumentComponent.FormBody document={documents} />
                        </Box>
                    )}

                    <Box pt={5}>
                        <ViewContactComponent.FormBody contactData={data} />
                    </Box>

                    <Box pt={5}>
                        <ViewPaymentComponent.FormBody paymentData={data} />
                    </Box>
                    <QuickScroll />

                </Box>
            </Paper>
            <Paper className='sticky-footer'>
                {/* <Paper> */}
                <Box alignItems='center'>
                    {isSubmitted ?
                        <SubmittedBookingButtonComponent
                            onMyBooking={navigateMyBooking}
                        />
                        : <ReviewBookingButtonComponent
                            onSaveDraft={onSaveDraft}
                            onEdit={onEdit}
                            onDiscard={onDiscard}
                            onSubmitBooking={onSubmitBooking}
                        />}

                </Box>
            </Paper>
            <ConfirmDialog
                isConfirmDialogOpen={confirmDialogOpen}
                closeDialog={() => setConfirmDialogOpen(false)}
                confirmDialog={navigateMyBooking}
                content={translatedTextsObject.dialogDiscardBookingContent}
                okMsg={uiTranslatedTextsObject.ok}
                cancelMsg={uiTranslatedTextsObject.cancel}
                title={translatedTextsObject.dialogDiscardBookingTitle}
            />
        </Box>
    )
}

const ReviewBookingFormProperties = Object.freeze({
    formikProps: FORMIK_PROPS,
    FormFields: FormFields
    // toClientDataFormat: toClientDataFormat,
    // toServerDataFormat: toServerDataFormat
})


export default ReviewBookingFormProperties